import React from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import ButtonWrapper, { LOG_IN, SIGN_UP } from '../ButtonWrapper';

const FacebookButton = ({ type, onClick }) => {
  const I18nPrefix = 'strava.landing_page';

  return (
    <ButtonWrapper
      className={styles.facebookButton}
      onClick={onClick}
      data-testid="facebook_auth_btn"
    >
      {type === SIGN_UP
        ? I18n.t(`${I18nPrefix}.here_to_join.facebook_cta_v2`)
        : 'implement_me'}
    </ButtonWrapper>
  );
};

FacebookButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf([SIGN_UP, LOG_IN]).isRequired
};

FacebookButton.defaultProps = {
  onClick: () => {}
};

export default FacebookButton;
